module.exports = __webpack_public_path__ + "img/mobile-neck-11_18x214.ed6075da.png";